"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeCell = void 0;
const react_1 = __importStar(require("react"));
const date_fns_1 = require("date-fns");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const locale_context_1 = require("../../../common/locale/locale-context");
const table_styles_1 = require("../table-styles");
const date_utils_1 = require("../../../utils/date-utils");
function TimeCell({ value }) {
    const classes = table_styles_1.useStyles();
    const { locale } = react_1.useContext(locale_context_1.LocaleContext);
    const parsed = date_utils_1.parseISOTimeSafe(value);
    const date = parsed ? date_fns_1.format(parsed, locale.timeFormat) : '';
    return react_1.default.createElement(Typography_1.default, { className: classes.tableCell }, date);
}
exports.TimeCell = TimeCell;
TimeCell.displayName = 'TimeCell';
//# sourceMappingURL=time-cell.js.map